import Big from 'big.js'

type Value = string | number

const PRECISION = 5

// Этот код взят отсюда https://github.com/jonschlinkert/is-number/blob/master.js там он покрыт тестами
export const isNumber = (num?: Value | null): num is number => {
  let number

  if (num === undefined) {
    number = NaN
  } else {
    number = num === null ? 0 : +num
  }

  if (number - number !== 0) {
    // Discard Infinity and NaN
    return false
  }

  if (number === num) {
    return true
  }

  if (typeof num === 'string') {
    return !(number === 0 && num.trim() === '')
  }

  return false
}

export const round = (x: Value, precision: number = PRECISION) => {
  try {
    return Big(x).round(precision).toString()
  } catch (e) {
    return ''
  }
}

export const plus = (x: Value, y: Value, precision: number = PRECISION) => {
  try {
    return Big(x).plus(y).round(precision).toString()
  } catch (e) {
    return ''
  }
}

export const minus = (x: Value, y: Value, precision: number = PRECISION) => {
  try {
    return Big(x).minus(y).round(precision).toString()
  } catch (e) {
    return ''
  }
}

export const multiply = (x: Value, y: Value, precision: number = PRECISION) => {
  try {
    return Big(x).times(y).round(precision).toString()
  } catch (e) {
    return ''
  }
}

export const div = (x: Value, y: Value, precision: number = PRECISION) => {
  try {
    return Big(x).div(y).round(precision).toString()
  } catch (e) {
    return ''
  }
}

export const eq = (x: Value, y: Value) => Big(x).eq(y)

export const compare = (x: Value, y: Value) => Big(x).cmp(y)
